var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtUnderlineAntikWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353.3 179.5",
    style: {
      enableBackground: "new 0 0 353.3 179.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#262324;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{display:inline;fill:#262324;}\n\t.st5{display:inline;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line_x5F_black",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 157.3,
    className: "st2",
    width: 146.5,
    height: 19.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line_x5F_white"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 156.2,
    className: "st3",
    width: 146.5,
    height: 19.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hambi",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 157.3,
    className: "st2",
    width: 146.5,
    height: 19.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 50.9,
    className: "st2",
    width: 146.5,
    height: 19.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 104.1,
    className: "st4",
    width: 146.5,
    height: 19.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "hambi_x5F_white",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 156.3,
    className: "st3",
    width: 146.5,
    height: 19.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 51.9,
    className: "st3",
    width: 146.5,
    height: 19.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 104.1,
    className: "st5",
    width: 146.5,
    height: 19.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "GRO_x5F_white_x5F_alier",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.9,51.8h-32.2l0-28.1l-23.7,0l0,68.2c0,20.4-4.2,36.7-12.6,48.4c-9,12.6-22.3,19.1-39.6,19.3h0 c-11.6,0-22.5-4.3-29.9-11.8c-7-7.1-10.6-16.6-10.5-27.4C23.7,106.6,29.5,95,40,87.9c11.8-8.1,28.2-9.4,44.8-3.4l9.3-12.1 L38.1,23.7h78V2.2H10.6v22.6L59,66.3L55.9,66c-1.8-0.2-3.6-0.3-5.3-0.3c-12.2,0-23.3,4.2-32.3,12.4C6.8,88.5,0,104.2,0,120.1 c0,15.7,6,30.2,16.8,41c11.2,11.1,26.9,17.3,44.1,17.4c0.1,0,0.2,0,0.3,0c11.6,0,22-2.5,31-7.4c8-4.4,14.9-10.7,20.5-18.8l0.3-0.4 l3.1,0l0,23.9l23.7,0l0-104h32.2L171.9,51.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_white_x5F_alier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.1,167.6L138.9,156V71.2l28.5-11.4v-8h-28.5V23.7h-14.5l-9.2,34.3l0,56.5l0,0 c-0.3,15.3-5.6,28.1-15.5,37.2c-9.8,9-23.1,13.4-36.7,12.3c-22.1-2.2-37.5-19.5-37.5-42.1c0-12.7,6.8-25.4,17.7-33 c11.6-8.1,26.1-9.6,40.9-4.4l7.5-9.5L36.7,23.7h49.9l9.4,33.1h8.5V2.2H12.4v22l52.1,43.5L61,67.2c-0.6-0.1-1-0.1-1-0.1 c-2.7-0.3-5.3-0.5-7.8-0.5c-16,0-27,6.6-33.8,12.6C6.9,89.3,0,104.7,0,120.1c0,15.6,6.2,30,17.5,40.8c11.6,11,27.8,17.2,45.6,17.5 c32.9,0.4,49.9-20.5,58.4-38.1l0.4-0.9l11.7,6.3l-16.3,30.2h44.7V167.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "GRO_x5F_black_x5F_Et",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.9,50.9h-32.2l0-26.1l-25.6,0l0,0h0l0,67.1c0,39-15.9,66.4-51.2,66.8c-21.1,0-39.8-14.3-39.4-38.2 c0.4-29.9,27.8-47,60.7-34.9l10.3-13.5L41.7,24.7h74.3V1.3H10.6v24.1L57,65.1c-35.5-3.5-57,27.2-57,55c0,32.2,24.9,59.2,61.9,59.4 c25.2,0.1,42-11.2,52.6-26.5l1.6,0l0,23.9l25.6,0l0-104h32.2L173.9,50.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_black_x5F_et",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.7,72l28.5-11.4v-9.7h-28.5v-0.1v-26h-16.2l-9.4,33.1l0,55.4l0,0c0,35-26.7,51.8-51.2,49.8 c-21-2.1-36.6-18.5-36.6-41.1c0-24.2,25-48.3,57.9-36.2l0,0l0,0c0,0,0,0,0,0l0,0l8.4-10.8L41,24.8h46.7l9.4,33.1h9.5V1.3H13.2v23.5 l49.8,41.6c-0.7-0.1-1-0.1-1-0.1C24,61.4,0.8,92,0.8,120.3c0,32.2,26.1,58.7,64.1,59.2c34.1,0.5,51.2-21.7,59.3-38.7l9.9,5.3 l-16.6,30.7h47.3v-9.8l-23.1-11.5v-83V72z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtUnderlineAntikWhite);
export default __webpack_public_path__ + "static/media/et-underline-antik-white.0b0d09a8500227759d1dfa880d17c7cd.svg";
export { ForwardRef as ReactComponent };